import { useState } from 'react';
import { Alert } from '@/components/ui/Alert';
import { useSites, type Site } from '@/features/sites/api';
import './trusted-sites.css';

/** The panel owns the order, row breaks and width of each logo. */
export function TrustedSitesPage() {
  const { data, isLoading, isError, refetch } = useSites();
  const sites = [...(data ?? [])].sort(
    (a, b) =>
      (a.trustedOrder ?? a.displayOrder) - (b.trustedOrder ?? b.displayOrder) ||
      a.name.localeCompare(b.name),
  );
  return (
    <div className="trusted-logo-page">
      <h1 className="sr-only">Güvenilir Siteler</h1>
      {isError ? (
        <Alert tone="error">
          Siteler yüklenemedi.{' '}
          <button
            onClick={() => {
              void refetch();
            }}
            className="underline"
          >
            Tekrar dene
          </button>
        </Alert>
      ) : null}
      {isLoading ? (
        <div className="trusted-logo-grid" role="status" aria-label="Siteler yükleniyor">
          {Array.from({ length: 8 }, (_, index) => (
            <div className="trusted-logo-skeleton" key={index} />
          ))}
        </div>
      ) : null}
      {!isLoading && !isError && sites.length === 0 ? (
        <p className="py-20 text-center text-sm text-surface-400">Henüz yayında bir site yok.</p>
      ) : null}
      {!isError && sites.length > 0 ? (
        <div className="trusted-logo-grid" aria-label="Güvenilir siteler">
          {sites.map((site) => (
            <LogoTile key={`${site.id}:${site.logoUrl}:${site.iconUrl}`} site={site} />
          ))}
        </div>
      ) : null}
    </div>
  );
}

function LogoTile({ site }: { site: Site }) {
  const [failed, setFailed] = useState(0);
  const columns = Math.max(1, Math.min(4, site.trustedColumns ?? 1));
  const source = failed === 0 ? (site.logoUrl ?? site.iconUrl) : failed === 1 ? site.iconUrl : null;
  return (
    <a
      className="trusted-logo-tile"
      href={`${site.clickUrl}?from=list`}
      target="_blank"
      rel="noopener noreferrer sponsored"
      aria-label={`${site.name} sitesini ziyaret et`}
      title={site.name}
      style={{ gridColumn: site.trustedNewRow ? `1 / span ${columns}` : `span ${columns}` }}
    >
      {source ? (
        <img
          src={source}
          alt=""
          width={480}
          height={160}
          loading="lazy"
          decoding="async"
          onError={() => setFailed((current) => current + 1)}
        />
      ) : (
        <svg aria-hidden viewBox="0 0 32 32" className="trusted-logo-placeholder">
          <path d="M13 10h-3a6 6 0 0 0 0 12h3m6-12h3a6 6 0 0 1 0 12h-3M11 16h10" />
        </svg>
      )}
    </a>
  );
}
